import { atom } from 'recoil';
import { User } from '../graphQl/api_generated';

export const userInfo = atom({
  key: 'userInfo',
  default: {} as User,
});
